import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import {
  createHashRouter,
  RouterProvider,
} from 'react-router-dom';
import ValidateSchemaNPayload from './components/validate-schema-n-payload/validate-schema-n-payload';
import JSONComparison from './components/json-comparison/json-comparison';
import App from './App';
import IsJSONSchemaValid from './components/is-json-schema-valid/is-json-schema-valid';
import ValidateOneFunctionSchemaNOnePayload from './components/validate-one-function-schema-n-one-payload/validate-one-function-schema-n-one-payload';
const router = createHashRouter([
  {
    path: '/',
    children: [
      {
        path: '',
        element: <App />,
      },
      {
        path: 'validate-schema-n-payload',
        element: <ValidateSchemaNPayload />,
      },
      {
        path: 'validate-one-function-schema-n-one-payload',
        element: <ValidateOneFunctionSchemaNOnePayload />,
      },
      {
        path: 'is-json-schema-valid',
        element: <IsJSONSchemaValid />,
      },
      {
        path: 'json-comparison',
        element: <JSONComparison />,
      }
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
